<script lang="ts" setup>
import type { ScheduleEvent, Team } from '~/types'

interface Props {
  scheduleEvent: ScheduleEvent.Model
  currentTeam: Team.Model
}
const props = defineProps<Props>()

const {
  currentTeamScore,
  opponentTeamScore,
  resultLabel,
  hasResults,
} = useScheduleEvent(props.scheduleEvent, props.currentTeam)
</script>

<template>
  <div
    v-if="hasResults"
    class="schedule-event-results"
  >
    <span
      v-if="resultLabel"
      class="schedule-event-results__result"
    >
      {{ resultLabel }}
    </span>
    <span
      class="schedule-event-results__result"
    >
      {{ currentTeamScore }}
    </span>
    <span
      class="schedule-event-results__result"
    >
      - {{ opponentTeamScore }}
    </span>
  </div>
</template>

<style scoped lang="scss">
.schedule-event-results {
  &__result {
    @apply pr-1;
  }
}
</style>
